import { App } from './App.tsx';
import { createBrowserRouter } from 'react-router-dom';
import { ErrorPresenter } from '@cmp/errorPresenter';
import { loader as createTokenLoader } from '@lnd/loaders/create-tokens';
import { loader as signOut } from '@/loaders/signout';
import { authenticatedLoader } from '@/loaders/authenticatedLoader';
import { registerLoader } from '@/loaders/registerLoader';
import { guestLoader } from '@/loaders/guestLoader';
import {
  LANDING,
  WINNERS,
  PARTICIPATING_STATIONS,
  FAQ,
  LOGIN,
  LOGIN_PASSWORD,
  ACCEPT_TERMS,
  REGISTER,
  RESET_PASSWORD,
  RESTORE_PASSWORD,
  AUTH_RESET_PASSWORD,
  AUTH_CREATE_TOKENS,
  AUTH_CALLBACK,
  LOGOUT,
  DASHBOARD,
  QR_VALIDATION,
  QR_WITH_CODE,
  EXCHANGE_CODES,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  ERROR,
  EXTERNAL_QR,
  PRIVACY_POLICIES,
  NOT_FOUND,
} from './routes';

export const createRouter = () => {
  return createBrowserRouter([
    {
      path: EXTERNAL_QR,
      lazy: async () => {
        const Component = (await import('@lnd/pages/external-qr')).default;
        return { Component };
      },
    },
    {
      path: '/',
      element: <App />,
      errorElement: <ErrorPresenter />,
      children: [
        {
          index: true,
          path: LANDING,
          lazy: async () => {
            const Component = (await import('@lnd/pages/home/landing')).default;
            return { Component };
          },
        },
        {
          path: WINNERS,
          lazy: async () => {
            const Component = (await import('@lnd/pages/home/winners')).default;
            return { Component };
          },
        },
        {
          path: PARTICIPATING_STATIONS,
          lazy: async () => {
            const Component = (await import('@lnd/pages/home/estaciones-participantes')).default;
            return { Component };
          },
        },
        {
          path: FAQ,
          lazy: async () => {
            const Component = (await import('@lnd/pages/home/FAQ')).default;
            return { Component };
          },
        },
        {
          loader: guestLoader,
          children: [
            {
              path: LOGIN,
              lazy: async () => {
                const Component = (await import('@lnd/pages/validacionIdentidad/iniciar-sesion')).default;
                return { Component };
              },
            },
            {
              path: LOGIN_PASSWORD,
              lazy: async () => {
                const Component = (await import('@lnd/pages/validacionIdentidad/iniciar-sesion-password')).default;
                return { Component };
              },
            },
          ],
        },

        {
          path: ACCEPT_TERMS,
          lazy: async () => {
            const Component = (await import('@lnd/pages/validacionIdentidad/iniciar-sesion-aceptar-terminos')).default;
            return { Component };
          },
        },

        {
          path: REGISTER,
          loader: registerLoader,
          lazy: async () => {
            const Component = (await import('@lnd/pages/validacionIdentidad/registro')).default;
            return { Component };
          },
        },

        {
          path: RESET_PASSWORD,
          lazy: async () => {
            const Component = (await import('@lnd/pages/validacionIdentidad/reiniciar-contrasena')).default;
            return { Component };
          },
        },

        {
          path: RESTORE_PASSWORD,
          lazy: async () => {
            const Component = (await import('@lnd/pages/validacionIdentidad/reenviar-contrasena.tsx')).default;
            return { Component };
          },
        },

        {
          path: AUTH_CREATE_TOKENS,
          loader: createTokenLoader,
        },

        {
          path: LOGOUT,
          loader: signOut,
        },

        {
          path: AUTH_RESET_PASSWORD,
          lazy: async () => {
            const Component = (await import('@lnd/pages/validacionIdentidad/reiniciar-contrasena')).default;
            return { Component };
          },
        },
        {
          loader: authenticatedLoader,
          children: [
            {
              path: DASHBOARD,
              lazy: async () => {
                const Component = (await import('@lnd/pages/home/home')).default;
                return { Component };
              },
            },
            {
              path: EXCHANGE_CODES,
              lazy: async () => {
                const Component = (await import('@lnd/pages/home/codes-register.tsx')).default;
                return { Component };
              },
            },
          ],
        },

        {
          path: QR_VALIDATION,
          lazy: async () => {
            const Component = (await import('@lnd/pages/qr-validation')).default;
            return { Component };
          },
        },
        {
          path: QR_WITH_CODE,
          lazy: async () => {
            const Component = (await import('@lnd/pages/home/qr-with-code')).default;
            return { Component };
          },
        },

        {
          path: AUTH_CALLBACK,
          lazy: async () => {
            const Component = await import('@lnd/pages/validacionIdentidad/auth-callback');
            return { Component: Component.default };
          },
        },

        {
          path: ERROR,
          lazy: async () => {
            const Component = await import('@lnd/pages/error');
            return { Component: Component.default };
          },
        },

        {
          path: TERMS_CONDITIONS,
          lazy: async () => {
            const Component = (await import('@lnd/pages/legal/terms-conditions')).default;
            return { Component };
          },
        },

        {
          path: PRIVACY_POLICY,
          lazy: async () => {
            const Component = (await import('@lnd/pages/legal/privacy-policy')).default;
            return { Component };
          },
        },

        {
          path: PRIVACY_POLICIES,
          lazy: () => import('@lnd/pages/privacy-policies'),
        },

        {
          path: NOT_FOUND,
          lazy: async () => {
            const Component = (await import('@lnd/pages/other/not-found')).default;
            return { Component };
          },
        },
      ],
    },
  ]);
};
